export default __webpack_public_path__ + "static/media/step_03.eba8fa2d.png";